module.exports = __webpack_public_path__ + "img/sablier.139b8756.png";